import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { monitoring } from './monitoring';

export const MonitorHistory: React.FC = () => {
	const { pathname } = useHistory().location;
	React.useEffect(() => monitoring.setCurrentRouteName(pathname), [pathname]);
	return null;
};
